import classNames from "classnames";
import React from "react";

// styles
import styles from "./pill.module.scss";

export interface PillProps extends React.HTMLProps<HTMLDivElement> {
  Lefticon?: React.ReactNode;
  Righticon?: React.ReactNode;
  styleName?: string;
}

const Pill: React.FC<PillProps> = ({
  Lefticon,
  Righticon,
  styleName = "primary",
  children,
  ...props
}: PillProps): JSX.Element => {
  return (
    <div className={classNames(styles["pill_container"], styleName)} {...props}>
      {Lefticon && <span>{Lefticon ? Lefticon : ""}</span>}
      {children}
      {Righticon && <span>{Righticon ? Righticon : ""}</span>}
    </div>
  );
};

export default Pill;
